const createRoute = (baseUrl) => (proxy, route) => `${baseUrl}/${proxy}/${route}`;

export const getEndpoint = (baseUrl) => {
  const setEndpoint = createRoute(baseUrl);

  return {
    quiz: setEndpoint('user', 'stq'),
    notification: setEndpoint('user', 'preferences'),
    pickHistory: setEndpoint('hockey', 'picks/history'),
    players: setEndpoint('hockey', 'picks'),
    playerPicks: setEndpoint('hockey', 'picks'),
    user: setEndpoint('hockey', 'user'),
    userStats: setEndpoint('hockey', 'user/stats'),
    leaderboard: setEndpoint('hockey', 'contest/challenge/leaderboard'),
    postSeasonLeaderboard: setEndpoint('hockey', 'contest/postseason/leaderboard'),
    seasonLeaderboard: setEndpoint('hockey', 'contest/season/leaderboard'),
    leaderboardLocal: setEndpoint('hockey', 'contest/challenge/leaderboard/local'),
    postSeasonLeaderboardLocal: setEndpoint('hockey', 'contest/postseason/leaderboard/local'),
    seasonLeaderboardLocal: setEndpoint('hockey', 'contest/season/leaderboard/local'),
  };
};
